import { isValidPrice } from './isValidPrice';
import { getNumberString } from './getNumberString';
import { isValidMaxNumber } from '../../../utils/validators';
import { EPriceErrorMessages } from '../constants';

export const validateGte = (gte: string, lte: string, required: boolean): string | null => {
  if (isValidPrice(gte) && !isValidMaxNumber(Number(getNumberString(gte)))) {
    return EPriceErrorMessages.Max;
  }

  return (!gte && !required) || isValidPrice(gte) || isValidPrice(lte) ? null : EPriceErrorMessages.GteRequired;
};

export const validateLte = (gte: string, lte: string, required: boolean): string | null => {
  if (isValidPrice(gte) && isValidPrice(lte) && Number(getNumberString(lte)) < Number(getNumberString(gte))) {
    return EPriceErrorMessages.GteLte;
  }

  if (isValidPrice(lte) && !isValidMaxNumber(Number(getNumberString(lte)))) {
    return EPriceErrorMessages.Max;
  }

  return (!lte && !required) || isValidPrice(lte) || isValidPrice(gte) ? null : EPriceErrorMessages.LteRequired;
};

export const validatePrice = (value: string, required: boolean) => {
  if (isValidPrice(value) && !isValidMaxNumber(Number(getNumberString(value)))) {
    return EPriceErrorMessages.Max;
  }

  return (!value && !required) || isValidPrice(value) ? null : EPriceErrorMessages.Required;
};
